import type { AvatarPageConfig } from '../types/avatar-page-config';

/**
 * 기본 아바타 UI 정보
 */
export const DEFAULT_AVATAR_UI_INFO = {
  profileImage: '/webp/kikiz-profile.webp',
  assets: [
    { name: '헤어', creator: '@scon' },
    { name: '얼굴', creator: '@scon' },
    { name: '옷', creator: '@scon' },
    { name: '바디', creator: '@scon' },
  ],
};

/**
 * 기본 아바타 페이지 설정
 * JSON으로 저장 가능한 설정만 포함
 */
export const DEFAULT_AVATAR_CONFIG: AvatarPageConfig = {
  consentModal: {
    // 기본 타이틀은 비워두고, 설정이 없으면 에이전트 이름으로 폴백한다
    // (custom-avatar-page.tsx: title || agentData?.name)
    title: '',
    description:
      '마이크 접근 권한이 필요합니다.',
    background: '#FFFFFF',
    image: '/webp/profile.webp',
    buttonText: '동의 후 대화하기',
  },
  inputControls: {
    blurStrength: 20,
    // placeholder, voiceButtonText, chatButtonText는 i18n 기본값 사용
  },
  chatOverlay: {
    background: '#FFFFFF',
    styleConfig: {
      aiProfileImage: '/webp/kikiz-profile.webp',
      messages: {
        botBubble: {
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          textColor: '#3B3B3B',
          borderRadius: 20,
          padding: 12,
          fontSize: 14,
          fontWeight: '500',
        },
        userBubble: {
          backgroundColor: 'rgba(141, 83, 255, 0.9)',
          textColor: '#FFFFFF',
          borderRadius: 20,
          padding: 12,
          fontSize: 14,
          fontWeight: '500',
        },
        spacing: 16,
      },
    },
  },
  greeting: {
    ko: '안녕하세요! 무엇을 도와드릴까요?',
    en: 'Hello! How can I help you?',
    ja: 'こんにちは！何かお手伝いできますか？',
    zh: '你好！有什么可以帮助你的吗？',
  },
};

/**
 * 공통 그라데이션 배경
 */
export const DEFAULT_GRADIENT = '#FFFFFF';
